<template>
	<section class="new-event-destination-info">
		<div class="new-event-destination-info__inner">
			<h2 v-if="destinationName">{{destinationName}}</h2>

			<div v-if="descriptionParagraphs.length" class="new-event-destination-info__description">
				<p v-for="(paragraph, index) in descriptionParagraphs" :key="index">
					{{paragraph}}
				</p>
			</div>

			<div v-if="destinationImageUrl" class="new-event-destination-info__image">
				<img
					:src="destinationImageUrl"
					:alt="destinationName"
				>
			</div>
		</div>
	</section>
</template>

<script>
import DestinationService from '../../services/DestinationService';
import { getStorageUrl } from '../../util';

export default {
	props: {
		event: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			destination: null,
			currentRequestKey: 0,
		};
	},
	computed: {
		languageCode() {
			return this.$store.state.language.lang;
		},
		destinationName() {
			if (this.destination && this.destination.name) return this.destination.name;
			return this.event && this.event.destination ? this.event.destination.name : '';
		},
		descriptionParagraphs() {
			const description = this.destination && this.destination.description
				? this.destination.description
				: '';
			return String(description)
				.split(/\r?\n|\u2028/)
				.map(paragraph => paragraph.trim())
				.filter(Boolean);
		},
		destinationImageUrl() {
			const imagePath = this.destination && this.destination.mainImagePath
				? this.destination.mainImagePath
				: '';
			if (!imagePath) return '';
			return /^https?:\/\//i.test(imagePath) ? imagePath : getStorageUrl(imagePath);
		},
	},
	watch: {
		event: {
			immediate: true,
			handler() {
				this.getDestination();
			},
		},
		languageCode() {
			this.getDestination();
		},
	},
	methods: {
		getDestination() {
			if (!this.event || !this.event.destination || !this.event.client) return;

			const requestKey = this.currentRequestKey + 1;
			this.currentRequestKey = requestKey;

			const destinationService = new DestinationService(this.event.client);
			destinationService.getCityByCode(this.event.destination.id, this.languageCode)
				.then(response => {
					if (this.currentRequestKey !== requestKey) return;
					const cities = response && response.data && response.data.cities
						? response.data.cities
						: [];
					this.destination = cities.length ? cities[0] : {};
				})
				.catch(() => {
					if (this.currentRequestKey === requestKey) this.destination = {};
				});
		},
	},
};
</script>

<style scoped lang="scss">
.new-event-destination-info {
	background: #ffffff;
	color: #5a5a5a;
}

.new-event-destination-info__inner {
	width: calc(100% - 214px);
	max-width: 1518px;
	margin: 0 auto;
	padding: 68px 0 76px;
}

.new-event-destination-info__inner h2 {
	margin: 0 0 40px;
	color: #163560;
	font-size: 28px;
	font-weight: 900;
	line-height: 33px;
}

.new-event-destination-info__description {
	margin-bottom: 64px;
	color: #5a5a5a;
	font-size: 18px;
	font-weight: 400;
	line-height: 35px;
}

.new-event-destination-info__description p {
	margin: 0 0 32px;
}

.new-event-destination-info__description p:last-child {
	margin-bottom: 0;
}

.new-event-destination-info__image img {
	display: block;
	width: 100%;
	height: auto;
	border-radius: 30px;
}

@media (max-width: 900px) {
	.new-event-destination-info__inner {
		width: 90%;
		padding: 48px 0 64px;
	}

	.new-event-destination-info__inner h2 {
		margin-bottom: 28px;
		font-size: 24px;
		line-height: 30px;
	}

	.new-event-destination-info__description {
		margin-bottom: 42px;
		font-size: 16px;
		line-height: 28px;
	}

	.new-event-destination-info__description p {
		margin-bottom: 24px;
	}

}

@media (max-width: 560px) {
	.new-event-destination-info__image img {
		border-radius: 22px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/destination-info/DestinationInfo.vue